import { ThemeUICSSObject, getColorsByPath, spacing } from '@apia/theme';
/* IMPORT HERE */

const tab: ThemeUICSSObject = {
  borderWidth: '1px',
  borderStyle: 'solid',

  '&>button': {
    variant: 'buttons.accordion',
    background: 'transparent',

    '& > *, & h3': {
      background: 'transparent',
      color: 'inherit',
    },
  },
  '&>div>div>*': {
    p: spacing(7),
    bg: 'tab.backgroundColor',
  },

  ...getColorsByPath('tab'),

  /* PREPEND HERE */
};

export default tab;
